<template>
  <v-list
    two-line
    subheader
    dense
  >
    <v-subheader
      class="primary white--text"
    >
      {{ subheader }} ({{ model.length }})
    </v-subheader>

    <div
      v-if="model.length === 0"
      class="grey--text my-3"
    >
      {{ emptyMessage }}
    </div>

    <template v-for="(task, index) in model">
      <TaskListItem
        :key="`mytask_${task.id}`"
        :task="task"
      />
      <v-divider
        v-if="index + 1 < model.length"
        :key="`divider_${task.id}`"
        inset
      />
    </template>
  </v-list>
</template>
<script>
  import TaskListItem from '@/components/Task/TaskListItem.vue'

  export default {
    components: {
      TaskListItem
    },
    props: {
      emptyMessage: {
        type: String,
        default: ''
      },
      subheader: {
        type: String,
        required: true
      },
      tasks: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        model: this.tasks
      }
    },
    watch: {
      tasks() {
        this.model = this.tasks
      }
    }
  }
</script>
<style>

</style>
